'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configurePermissions;

var _roles = require('./roles');

function configurePermissions(AuthService, PermPermissionStore, PermRoleStore) {
  'ngInject';

  PermRoleStore.defineRole(_roles.ANONYMOUS, function () {
    return !AuthService.isLoggedIn;
  });
  // eslint-disable-next-line max-len
  PermRoleStore.defineRole(_roles.USER, function () {
    return AuthService.isLoggedIn && !AuthService.isCompanyAdmin && !AuthService.isSysAdmin && !AuthService.isRegulator;
  });
  PermRoleStore.defineRole(_roles.REGULATOR, function () {
    return AuthService.isRegulator;
  });
  PermRoleStore.defineRole(_roles.REGULATOR_ADMIN, function () {
    return AuthService.isRegulatorAdmin;
  });
  PermRoleStore.defineRole(_roles.COMPANY_ADMIN, function () {
    return AuthService.isCompanyAdmin;
  });
  PermRoleStore.defineRole(_roles.SYS_ADMIN, function () {
    return AuthService.isSysAdmin;
  });
}


// WEBPACK FOOTER //
// ./config/permissions/permissions.config.js